import { motion, AnimatePresence } from "framer-motion"
import { MessageCircle, X } from "lucide-react"
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { buildWhatsAppLink } from "@/lib/inquiry"
import { useOutboundTracking } from "@/hooks/useOutboundTracking"

export function QuickInquiry() {
  const [isOpen, setIsOpen] = useState(false)
  const trackOutbound = useOutboundTracking()
  const whatsappLink = buildWhatsAppLink(
    "919404679370",
    "Hi, I'm interested in your products/services"
  )

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="absolute bottom-16 right-0 mb-4 w-72 overflow-hidden rounded-2xl border border-slate-200/90 bg-white/95 shadow-[0_24px_50px_-28px_rgba(15,23,42,0.55)] backdrop-blur"
          >
            <div className="bg-gradient-to-r from-maxi-navy via-[#245F9F] to-maxi-cyan p-4 text-white">
              <h4 className="font-semibold">Quick Inquiry</h4>
              <p className="text-sm text-slate-100/95">We typically reply within minutes</p>
            </div>
            <div className="space-y-3 bg-slate-50/70 p-4">
              <Button
                variant="cta"
                className="w-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/25 hover:bg-[#1EBE5D] hover:shadow-[#25D366]/35"
                asChild
              >
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    trackOutbound(whatsappLink, {
                      label: "quick_inquiry_whatsapp",
                      placement: "floating_widget",
                      channel: "whatsapp",
                    })
                  }
                >
                  <MessageCircle className="h-5 w-5 mr-2" />
                  Chat on WhatsApp
                </a>
              </Button>
              <Button
                variant="outline"
                className="w-full border-slate-300 bg-white text-slate-800 hover:border-slate-400 hover:bg-slate-100 hover:text-slate-900"
                asChild
              >
                <a
                  href="tel:+919404679370"
                  onClick={() =>
                    trackOutbound("tel:+919404679370", {
                      label: "quick_inquiry_call",
                      placement: "floating_widget",
                      channel: "phone",
                    })
                  }
                >
                  Call Now: +91 94046 79370
                </a>
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close quick inquiry" : "Open quick inquiry"}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-maxi-cyan text-white shadow-lg shadow-maxi-cyan/35 transition-colors hover:bg-[#276F7F]"
      >
        {isOpen ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </motion.button>
    </div>
  )
}
